import Menu from './material_management.vue';

export default Menu;
